// extracted by mini-css-extract-plugin
export default {"value":"TechnologyFactors_value__HNtt6","wrapper":"TechnologyFactors_wrapper__MXIVO"};